requestAnimationFrame(() => {
  themeBase.onDOMContentLoadedTrigger(() => {
    scriptController.executeWhenScriptLoaded('cart.js', () => {
      if (!customElements.get('product-form')) {
        class ProductForm extends HTMLElement {
          constructor() {
            super();
          }

          connectedCallback() {
            this.form = this.querySelector('form');
            this.recipientFieldsInputs = this.closest('product-info')?.querySelectorAll('.js-personalized-fields input, textarea');

            if (this.form) {
              this.form.querySelector('[name=id]').disabled = false;
              this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
            }

            this.findElements();
            this.initAnimatedButton();

            scriptController.scripts.push('product-form.js');
          }

          findElements() {
            this.quickAddModal = this.closest('quick-add-modal');
            this.submitButton = this.querySelector('[type="submit"]');
          }

          disconnectedCallback() {
            if (this.animatedButtonInterval) clearInterval(this.animatedButtonInterval);
          }

          initAnimatedButton() {
            this.animatedButton = this.querySelector('.js-animated-product-button');

            if (!this.animatedButton) return;

            this.animatedButtonTimeout = 2000;
            this.animatedButtonInterval = setTimeout(() => this.animateButton(this.animatedButton), this.animatedButtonTimeout);
          }

          animateButton() {
            this.animatedButton.addEventListener('animationend', () => {
              this.animatedButton.classList.remove('button--css-animate');
              setTimeout(() => {
                this.animateButton(this.animatedButton);
              }, this.animatedButtonTimeout);
            }, {
              once: true
            });
            this.animatedButton.classList.add('button--css-animate');
          }

          onSubmitHandler(event, callback, enableEventCall = true) {
            event.preventDefault();
            this.clearPersonalizedFieldsErrors();

            const personalizedFieldsErrors = this.validatePersonalizedFields();

            if (personalizedFieldsErrors.length) {
              this.onError(personalizedFieldsErrors);
              return;
            }

            event.target.focus();
            this.findElements();

            if (this.submitButton && this.submitButton?.classList.contains('loading')) return;

            this.onError();
            cartBase.addToCart({
              body: new FormData(this.form),
              target: this,
              onLoadingToggle: (isLoading) => {
                this.toggleProductLoading({
                  isLoading,
                  processForm: false
                });
                cartBase.toggleCartLoading({
                  isLoading
                });

                if (!isLoading) {
                  this.quickAddModal?.hide(true);

                  if (callback) callback();
                }
              },
              enableEventCall
            });
          }

          clearPersonalizedFieldsErrors() {
            if (!this.recipientFieldsInputs) return;

            this.recipientFieldsInputs.forEach(element => {
              element.classList.remove('error');
            });
          }

          validatePersonalizedFields() {
            const errors = [];

            if (this.recipientFieldsInputs) {
              this.recipientFieldsInputs.forEach(element => {
                if (element.hasAttribute('required') && element.value.trim() === '') {
                  element.classList.add('error');
                  if (errors.indexOf(window.cartStrings.emptyFieldError) == -1) {
                    errors.push(window.cartStrings.emptyFieldError);
                  }
                }

                if (element.getAttribute('maxlength') && element.value.length > parseInt(element.getAttribute('maxlength'))) {
                  element.classList.add('error');
                  if (errors.indexOf(window.cartStrings.maxLengthError) == -1) {
                    errors.push(window.cartStrings.maxLengthError.replace(
                      '{{ value }}',
                      element.getAttribute('maxlength')));
                  }
                }
              });
            }

            return errors;
          }

          toggleProductLoading({
            isLoading,
            processForm = true,
            processButton = true
          }) {
            this.findElements();

            if (processButton && this.submitButton) {
              this.submitButton.toggleAttribute('aria-disabled', isLoading);
              this.submitButton.classList.toggle('loading', isLoading);
            }

            if (processForm) {
              this.classList.toggle('product-form--loading', isLoading);
            }
          }

          onError(errors) {
            this.querySelector('error-messages')?.show(errors);
            document.querySelector('push-messages')?.push(errors);
          }
        }

        customElements.define('product-form', ProductForm);
      }
    });
  });
});